import React from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';

import "./reliability-gauge-ui.css"
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../misc/tools';

export enum ReliabilityGaugeType {
	Type1,
	Type2,
	Type3,
	Type4,
	Type5,
	Type6,
	Type7,
	Type8,
	Type9
}

class ReliabilityGaugeUICaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'reliability-gauge-bg-1',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge1-bg.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-guage-needle-1',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge1-needle.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-gauge-bg-2',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge2-bg.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-guage-needle-2',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge2-needle.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-gauge-bg-3',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge3-bg.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-guage-needle-3',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge3-needle.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-gauge-bg-4',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge4-bg.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-guage-needle-4',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge4-needle.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-gauge-bg-5',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge5-bg.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-guage-needle-5',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge5-needle.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-gauge-bg-6',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge6-bg.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reliability-guage-needle-6',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/gauge6-needle.svg'
			},
			{
                type: PrecacheItemType.Image,
                key: 'reliability-gauge-bg-7',
                src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/reliability-gauge-bg-7.png'
            },
            {
                type: PrecacheItemType.Image,
                key: 'reliability-guage-needle-7',
                src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/reliability-guage-needle-7.png'
            },
            {
                type: PrecacheItemType.Image,
                key: 'reliability-gauge-bg-8',
                src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/reliability-gauge-bg-8.png'
            },
            {
                type: PrecacheItemType.Image,
                key: 'reliability-guage-needle-8',
                src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/reliability-guage-needle-8.png'
            },
            {
                type: PrecacheItemType.Image,
                key: 'reliability-gauge-bg-9',
                src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/reliability-gauge-bg-9.png'
            },
			{
                type: PrecacheItemType.Image,
                key: 'reliability-guage-needle-9',
                src: process.env.PUBLIC_URL + '/assets/images/scenarios/reliability-gague/reliability-guage-needle-9.png'
            }
		];
	}
}

export const reliabilityGaugeUICaching = new ReliabilityGaugeUICaching();

const ReliabilityGaugeUI = (props: ReliabilityGaugeUIConfig) => {
	const renderBasedOnType = () => {
		switch(props.type) {
			case ReliabilityGaugeType.Type1:
				return (
					<div className='reliability-gauge-ui-type-1-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-1-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-1').src} />
						</div>

						<div className='reliability-gauge-ui-type-1-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-1-needle-img-container-rotation' style={{
								transform: 'rotate(' + (((113+70)*props.percentage)-113) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							className='make-white' src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-1').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type2:
				return (
					<div className='reliability-gauge-ui-type-2-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-2-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-2').src} />
						</div>

						<div className='reliability-gauge-ui-type-2-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-2-needle-img-container-rotation' style={{
								transform: 'rotate(' + (((155+20)*props.percentage)-155) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-2').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type3:
				return (
					<div className='reliability-gauge-ui-type-3-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-3-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-3').src} />
						</div>

						<div className='reliability-gauge-ui-type-3-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-3-needle-img-container-rotation' style={{
								transform: 'rotate(' + (((193+72)*props.percentage)-193) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-3').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type4:
				return (
					<div className='reliability-gauge-ui-type-4-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-4-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-4').src} />
						</div>

						<div className='reliability-gauge-ui-type-4-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-4-needle-img-container-rotation' style={{
								transform: 'rotate(' + (((81+89)*props.percentage)-81) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-4').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type5:
				return (
					<div className='reliability-gauge-ui-type-5-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-5-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-5').src} />
						</div>

						<div className='reliability-gauge-ui-type-5-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-5-needle-img-container-rotation' style={{
								transform: 'rotate(' + (((66+184)*props.percentage)-66) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-5').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type6:
				return (
					<div className='reliability-gauge-ui-type-6-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-6-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-6').src} />
						</div>

						<div className='reliability-gauge-ui-type-6-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-6-needle-img-container-rotation' style={{
								transform: 'rotate(' + (((60+115)*props.percentage)-60) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-6').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type7:
				return (
					<div className='reliability-gauge-ui-type-7-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-7-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-7').src} />
						</div>

						<div className='reliability-gauge-ui-type-7-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-7-needle-img-container-rotation' style={{
								transform: 'rotate(' + ((180 * props.percentage) - 90) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-7').src} />
							</div>
						</div>
					</div>
				);
			case ReliabilityGaugeType.Type8:
				return (
					<div className='reliability-gauge-ui-type-8-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-8-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-8').src} />
						</div>

						<div className='reliability-gauge-ui-type-8-needle-img-container' style={{
                                left: ((200 * props.percentage) + 10) + 'px'
                            }}>
                            <img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-8').src} />
                        </div>
					</div>
				);
			case ReliabilityGaugeType.Type9:
				return (
					<div className='reliability-gauge-ui-type-9-container center-element-horizontal'>
						<div className='reliability-gauge-ui-type-9-bg-img-container'>
							<img aria-label='Reliability Gauge Background' src={reliabilityGaugeUICaching.getItemByKey('reliability-gauge-bg-9').src} />
						</div>

						<div className='reliability-gauge-ui-type-9-needle-img-container center-element-horizontal'>
							<div className='reliability-gauge-ui-type-9-needle-img-container-rotation' style={{
								transform: 'rotate(' + ((310 * props.percentage) - 220) + 'deg)'
							}}>
								<img aria-label={'Reliability Gauge ' + (props.percentage * 100) + '%'} 
							alt={'The Reliability Gauge is at ' + (props.percentage * 100) + '%'} 
							src={reliabilityGaugeUICaching.getItemByKey('reliability-guage-needle-9').src} />
							</div>
						</div>
					</div>
				);
		}
	}

	return (
		<div className="modal-disable-select main-content reliability-gauge-ui-container" style={{
		}}>
			{renderBasedOnType()}
			<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text reliability-gauge-ui-container-title white-text'>Reliability Gauge</p>
		</div>
	);

};

export interface ReliabilityGaugeUIConfig extends BaseConfig {
	type: ReliabilityGaugeType;
	percentage: number //0-1
}

export default ReliabilityGaugeUI;